/**
 * @generated SignedSource<<774e10637d7dd3cbfe7963aae4e07591>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeliverKind = "EQUAL" | "WEIGHT" | "%future added value";
export type UpdateDeliverableInput = {
  clientMutationId?: string | null;
  deliverableId: string;
  deliverKind: DeliverKind;
};
export type ABTestDetailPageContainer_updateDeliverKindMutation$variables = {
  input: UpdateDeliverableInput;
};
export type ABTestDetailPageContainer_updateDeliverKindMutationVariables = ABTestDetailPageContainer_updateDeliverKindMutation$variables;
export type ABTestDetailPageContainer_updateDeliverKindMutation$data = {
  readonly updateDeliverable: {
    readonly deliverable: {
      readonly id: string;
      readonly deliverKind: DeliverKind | null;
    };
  } | null;
};
export type ABTestDetailPageContainer_updateDeliverKindMutationResponse = ABTestDetailPageContainer_updateDeliverKindMutation$data;
export type ABTestDetailPageContainer_updateDeliverKindMutation = {
  variables: ABTestDetailPageContainer_updateDeliverKindMutationVariables;
  response: ABTestDetailPageContainer_updateDeliverKindMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliverKind",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ABTestDetailPageContainer_updateDeliverKindMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateDeliverablePayload",
        "kind": "LinkedField",
        "name": "updateDeliverable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "deliverable",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ABTestDetailPageContainer_updateDeliverKindMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateDeliverablePayload",
        "kind": "LinkedField",
        "name": "updateDeliverable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "deliverable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a9a25a34e484541b9085ca631a9c837",
    "id": null,
    "metadata": {},
    "name": "ABTestDetailPageContainer_updateDeliverKindMutation",
    "operationKind": "mutation",
    "text": "mutation ABTestDetailPageContainer_updateDeliverKindMutation(\n  $input: UpdateDeliverableInput!\n) {\n  updateDeliverable(input: $input) {\n    deliverable {\n      __typename\n      id\n      deliverKind\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f86ab8f673f10256fc303df9300b88d2";

export default node;
